import React from "react";
import PropTypes from "prop-types";
import { useIntl, FormattedMessage } from "react-intl";
import { Modal, Button } from "@ebsco-ui/ebsco-ui";
import sharedMessages from "../../../../../shared-messages";
import messages from "./confirm-merge-modal-messages";

import "./confirm-merge-modal.scss";
const block = "confirm-merge-modal";

const ConfirmMergeModal = ({
  isOpen,
  onClose,
  onConfirm,
  parentSelector,
  sourceAccountUsername
}) => {
  const { formatMessage } = useIntl();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      modalTitle={formatMessage(messages.continueWithMerge)}
      className={block}
      parentSelector={parentSelector}
    >
      <Modal.Header
        className={`${block}__header`}
        closeButtonProps={{
          title: formatMessage(sharedMessages.close),
          onClick: onClose
        }}
      >
        <h2 className={`${block}__title`}>
          {formatMessage(messages.continueWithMerge)}
        </h2>
      </Modal.Header>
      <Modal.Body className={`${block}__body`}>
        <FormattedMessage
          {...messages.deletionWarning}
          values={{
            sourceAccountUsername,
            styledUsername: displayStyledUserName(block)
          }}
        />
      </Modal.Body>
      <Modal.Footer className={`${block}__footer`}>
        <Button
          className={`${block}__continue-button`}
          onClick={onConfirm}
          styleType="default"
        >
          {formatMessage(sharedMessages.continue)}
        </Button>
        <Button
          className={`${block}__cancel-button`}
          onClick={onClose}
          styleType="link"
        >
          {formatMessage(sharedMessages.cancel)}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const displayStyledUserName = baseClassName => msg => (
  <span className={`${baseClassName}__username`}>{msg}</span>
);

ConfirmMergeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  sourceAccountUsername: PropTypes.string.isRequired
};

export default ConfirmMergeModal;
